import {
Button,
Modal,
ModalBody,
ModalCloseButton,
ModalContent,
ModalHeader,
ModalOverlay,

useToast
} from '@chakra-ui/react';
import React,{ useCallback } from 'react';
import TicTacToeGame from '../../classes/TicTacToeGame';
import useCoveyAppState from '../../hooks/useCoveyAppState';
import useMaybeVideo from '../../hooks/useMaybeVideo';


type StartTicTacToeGameModalProps = {
    isOpen: boolean;
    closeModal: ()=>void;
    startGameModal: ()=>void;
    updateTicTacToeGame: (game: TicTacToeGame)=>void;
    newTicTacToeGame: TicTacToeGame;
}
export default function StartTicTacToeGameModal( {isOpen, closeModal, startGameModal, updateTicTacToeGame, newTicTacToeGame} : StartTicTacToeGameModalProps): JSX.Element {
    const {apiClient, sessionToken, currentTownID, myPlayerID} = useCoveyAppState();

    const toast = useToast()
    const video = useMaybeVideo()

    const startGame = useCallback(async () => {
      try {
        newTicTacToeGame.addOccupant(myPlayerID);
        await apiClient.createTicTacToe({
          sessionToken,
          coveyTownID: currentTownID,
          ticTacToeGame: newTicTacToeGame.toServerTicTacToeGame(),
        });
        toast({
          title: 'Tic Tac Toe Game Created!',
          status: 'success',
        });
        video?.unPauseGame();
        updateTicTacToeGame(newTicTacToeGame);
        closeModal();
        startGameModal();
      } catch (err) {
        toast({
          title: 'Unable to create Tic Tac Toe Game',
          description: err.toString(),
          status: 'error',
        });
      }
    }, [myPlayerID, newTicTacToeGame, apiClient, sessionToken, currentTownID, toast, video, updateTicTacToeGame, closeModal, startGameModal]);
    
    return (
      <Modal isOpen={isOpen} onClose={()=>{closeModal(); video?.unPauseGame()}}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Start a new Tic Tac Toe Game? </ModalHeader>
          <ModalCloseButton />
            <ModalBody pb={6}>
            <Button colorScheme='blue' mr={3} onClick={startGame}>
                Start Game
              </Button>
              <Button onClick={closeModal}>Cancel</Button>
            </ModalBody>
        </ModalContent>
      </Modal>
    );
}

